import axios from "axios"
import { IOpenMessageModal } from "./ImportPricingModelView";
import { envF } from "../../../env";
import renderGlobalAlert from "../../../system/hooks/useGlobalAlert";

export const exportPricingRequest = async (
    idGlobal: string,
    setOpenMessage: (value: IOpenMessageModal) => void
) => {
        const jwtToken = localStorage.getItem("TokenData") as string;
        const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;

        const generateRequestUrl = (prefix: string, endPoint?: string) => {
            if (endPoint) {
                return `${envF.REACT_APP_API_GATEWAY_PATH}/${prefix}/${endPoint}`
            } else {
                return `${envF.REACT_APP_API_GATEWAY_PATH}/${prefix}`
            }
        }

        await axios.get(
            generateRequestUrl('Pricing', `${idGlobal}/ExportModel`),
            {
                headers: {
                    Authorization: token
                },
            }
        ).then((e) => {
            if (e.status === 200) {
                const blob = new Blob([JSON.stringify(e.data)], {
                    type: 'application/json'
                })
                saveAs(blob, e.data.PricingModel.Name + ".json")                
                setOpenMessage({ open: true, message: 'Модель ценообразования экспортирована успешно' })
            }
        }).catch((ex) => {
            renderGlobalAlert({
                variant: "exception",
                title: JSON.parse(ex.response.data.title).title,
                detail: ex.response.data.detail,
                statusCode: 500,
            });
        })
}


